<template>
    <div class="subPage">
        <img src="" alt="">
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Invitation',
  meta:{page:true},
  created() {
      this.$store.dispatch('school/getAllCourse');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/page/Invitation.vue